import { render, staticRenderFns } from "./AppAPIIcon.vue?vue&type=template&id=3b9cfb9c"
import script from "./AppAPIIcon.vue?vue&type=script&lang=js"
export * from "./AppAPIIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports